import React, { useContext } from 'react'
import { Trans } from 'react-i18next'
import { DirectionContext } from '../Contexts/DirectionContext';


export default function ServicesSection({ cardsData }) {
    const { dir } = useContext(DirectionContext);
 

    const Card = ({ image, Title, TitleEn, description, descriptionEn, Hoverd_image}) => (
        <div className="col-md-6  col-xl-3 card-container">
            <div className="card gap-4">
                <img src={require(`../../Assets/images/Services/${image}`)} alt={Title} className="card-image" />
                <h4 className="card-text title">{dir === 'ltr' ? TitleEn : Title}</h4>
                <div className="card-hover-content p-3">
                    <img src={require(`../../Assets/images/Services/${Hoverd_image}`)} alt={Title} />
                    <h4 className="card-text">{dir === 'ltr' ? TitleEn : Title}</h4>
                    <p className="card-text-subtitle">{dir === 'ltr' ? descriptionEn : description}</p>
                </div>
            </div>
        </div>
    );
    return (

        <div className="col-md-11">
            <div className="row g-3 g-xl-5 wow fadeIn justify-content-center" data-wow-delay="1.0s">
                {cardsData.map(card => (
                    <Card key={card.id} {...card} />
                ))}
            </div>
        </div>


    )
}
